export function loadLocaleMessages(): Record<string, unknown> {
  const messages = import.meta.glob("@/locales/**/*.ts", { eager: true });

  const messagesLocales: Record<string, unknown> = {};

  Object.entries(messages).forEach(([key, value]) => {
    const regex = /\/([a-z]{2})\/(.*)\.ts/;
    const t = regex.exec(key);

    const locale = (t ?? [])[1];

    if (!locale) {
      return;
    }

    messagesLocales[locale] = Object.assign(
      messagesLocales[locale] ?? {},
      (value as unknown as { default: Record<string, unknown> }).default,
    );
  });

  return messagesLocales;
}
